'use strict';

const cleave = require('./cleave');
var scrollAnimate = require('../components/scrollAnimate');
var formHelpers = require('../checkout/formErrors');

module.exports = {
    formatPhone: function () {
        let currentCountry =  $('input[name=current-country]').val();
        if (currentCountry) {
            cleave.formatPhoneNumber('.contactus-phone', currentCountry);
        }
    },

    submitContactUsForm: function () {
        $('.contact-us-form-sumbit').on('click', function (e) {
            $.spinner().start();
            e.preventDefault();
            const $contactUsForm = $('.contactus-supportform-js');

            $.ajax({
                url: $contactUsForm.attr('action'),
                type: 'POST',
                dataType: 'json',
                data: $contactUsForm.serialize(),
                success: function (data) {
                    if (data?.error) {
                        if (data?.fieldErrors?.length) {
                            data.fieldErrors.forEach(function (error) {
                                if (Object.keys(error).length) {
                                    formHelpers.loadFormErrors('.contactus-supportform-js', error);
                                }
                            });
                            
                            $('input.is-invalid, select.is-invalid, textarea.is-invalid').first()?.focus()

                            $.spinner().stop();
                            scrollAnimate($('.invalid-feedback'));
                        }
                        if (data?.serverErrors?.length) {
                            data.serverErrors.forEach(function (error) {
                                $('.error-message-js').removeClass('d-none');
                                $('.error-message-text-js').text(error);
                                $.spinner().stop();
                                scrollAnimate($('.error-message-js'));
                            });
                        }
                    } else {
                        window.location.href = data.url
                    }
                },
                error : function () {
                    $.spinner().stop();
                }
            });
            
        });
    }
    
};

